import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../buttons/button';
import { PendingFormIcon } from '../Icons/svgIcons';

const StatsOverviewCard = ({ title, count, icon, onViewAll, path, showViewAll = true }) => {
  const navigate = useNavigate();

  const handleViewAll = () => {
    if (onViewAll) onViewAll();
    else if (path) navigate(path);
  };

  const isDisabled = count === 0;

  return (
    <div className="bg-white rounded-xl border-2 border-gray-200 p-4 flex flex-col justify-between h-full min-h-[130px] shadow-sm transition-all duration-300 hover:shadow-lg hover:-translate-y-0.5">
      <div className="flex items-start justify-between mb-3">
        <div className="flex flex-col gap-1">
          <span className="text-gray-500 text-[12px] font-bold uppercase tracking-wider">{title}</span>
          <span className="text-gray-900 text-2xl font-bold tracking-tight">{count}</span>
        </div>
        {icon && (
          <div className="w-9 h-9 rounded-lg icon-bg-theme flex items-center justify-center flex-shrink-0">
            {React.cloneElement(icon, { className: "w-5 h-5 icon-theme" })}
          </div>
        )}
      </div>

      {showViewAll && (
        <div className="mt-auto pt-2 border-t border-gray-50">
          <Button 
            onClick={handleViewAll} 
            disabled={isDisabled}  
            variant="secondary" 
            size="small"
            fullWidth
            className="text-xs font-semibold shadow-none"
            icon={<PendingFormIcon className="w-5 h-5" />}
          >
            View All
          </Button>
        </div>
      )}
    </div>
  );
};

export default StatsOverviewCard;